import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Box, Heading } from 'lucid-components-react';

import {
  Drupal_FieldParagraphFlexiStyledMultiSectionsFieldSections,
  Drupal_ParagraphFlexiSection
} from 'generated/graphql';
import { getProcessedValue } from 'utils/helpers';
import { Text } from 'theme/typography';
import Link from 'components/link/link';

interface Props {
  entities: Drupal_FieldParagraphFlexiStyledMultiSectionsFieldSections[];
}

const BackAndForth = ({ entities }: Props) => {
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      justifyContent="flex-end"
      mb={{ default: 4, tablet: 11 }}
      mt={{
        default: 0,
        tablet: -10
      }}
      px={{ default: 0, tablet: 6 }}
    >
      {entities.map(({ entity }, i) => {
        const {
          fieldFlexiHeader,
          fieldFlexiBody,
          fieldFlexiImage,
          fieldFlexiLink
        } = entity as Drupal_ParagraphFlexiSection;

        return (
          <Box
            key={fieldFlexiHeader}
            display={{
              default: 'block',
              tablet: 'flex'
            }}
            justifyContent="space-between"
            mb={{
              default: 10,
              tablet: 6
            }}
            width={{
              default: 'auto',
              tablet: '820px'
            }}
          >
            <Box
              mx={{
                default: -4,
                tablet: 0
              }}
              order={{
                default: 1,
                tablet: i % 2 === 0 ? 2 : 1
              }}
              width={{
                default: 'auto',
                tablet: '460px'
              }}
            >
              <img
                alt={fieldFlexiHeader!}
                css={{
                  width: '100%'
                }}
                src={fieldFlexiImage!}
              />
            </Box>
            <Box
              alignSelf="center"
              order={{
                default: 2,
                tablet: i % 2 === 0 ? 1 : 2
              }}
              width="320px"
            >
              <Heading variant="subheadS700">{fieldFlexiHeader}</Heading>
              <Text
                as="div"
                textStyles="bodyS400"
              >
                {ReactHtmlParser(getProcessedValue(fieldFlexiBody))}
              </Text>
              {fieldFlexiLink && (
                <Link hasArrow primary to={fieldFlexiLink?.url?.path || ''}>
                  {fieldFlexiLink?.title}
                </Link>
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default BackAndForth;
